export const DEFAULT_FONT_SIZE_IN_PIXELS = 16;
